/**
 * @see [SegmentationType]{@link https://msasg.visualstudio.com/Bing_Ads/_git/AdsAppsMT#path=%2Fprivate%2FCampaign%2FMT%2FSource%2FInterface%2FEntity%2FAggregator2%2FSegmentationType.cs&version=GBmaster&_a=contents}
 */
export const Day = 'Day';
export const Week = 'Week';
export const Month = 'Month';
export const Quarter = 'Quarter';
export const Year = 'Year';
export const DayOfTheWeek = 'DayOfTheWeek';
export const HourOfTheDay = 'HourOfTheDay';
export const DeviceType = 'DeviceType';
export const Network = 'Network';
export const TopVsOther = 'TopVsOther';
export const DeliveredMatchType = 'DeliveredMatchType';
export const BiddedMatchType = 'BiddedMatchType';
export const Medium = 'Medium';
export const Currency = 'Currency';
export const DeviceOS = 'DeviceOS';
export const AdPosition = 'AdPosition';
export const DomainType = 'DomainType';
export const GoalType = 'GoalType';
export const GoalName = 'GoalName';
export const GoalCategory = 'GoalCategory';
export const AudienceType = 'AudienceType';
export const AudienceName = 'AudienceName';
export const AdScenario = 'AdScenario';

/**
 * @see [Segment]{@link https://msasg.visualstudio.com/Bing_Ads/_git/AdInsights#path=%2Fprivate%2FMTv2%2FInterfaces%2FAuctionInsight%2FAuctionInsightCommon.cs&version=GBmaster&_a=contents}
 */
export const Hour = 'Hour';
// These segmentation types are defined using same name in Campaign OData & Auction Insight
// export const Day = 'Day';
// export const Week = 'Week';
// export const Month = 'Month';
// export const Quarter = 'Quarter';
// export const Year = 'Year';
export const DayOfWeek = 'DayOfWeek';
export const Device = 'Device';
export const HourOfDay = 'HourOfDay';
